{
  "auth": {
    "authority": "https://login.microsoftonline.com/6b29189e-3d5d-4d76-970c-abe758468ae4",
    "validateAuthority": true,
    "navigateToLoginRequestUrl": true
  },
  "cache": {
    "cacheLocation": "localStorage"
  },
  "scopes": {
    "loginRequest": ["openid", "profile"]
  },
  "resources": {
    "graphApi": {
      "resourceUri": "https://graph.microsoft.com/v1.0/me/memberOf",
      "resourceScope": "GroupMember.Read.All"
    }
  },
  "groups": {
    "groupAllUsers": "f4993bb0-813b-4aa1-8e9d-dfd61f0408dd"
  }
}
